import {
  Dialog as MuiDialog,
  DialogContent,
  DialogTitle,
  IconButton,
  //   styled,
} from "@mui/material";
import { colors, tokens } from "../../styles";
import { displayFlexAlignItemsCenterJustifyContentSpaceBetween } from "../../styles/common/flexProperties";
import Typography from "../Typography";
import CloseIcon from "@mui/icons-material/Close";

const Modal = ({ open, handleClose, title, maxWidth = "510px", children }) => {
  return (
    <MuiDialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: colors.back21,
          backgroundImage: "none",
          borderRadius: "20px",
          maxWidth,
        },
      }}
    >
      {title && title !== "" && (
        <DialogTitle
          sx={{
            ...displayFlexAlignItemsCenterJustifyContentSpaceBetween,
            borderBottom: `1px solid ${colors.greyD9}`,
            padding: "20px 35px !important",
          }}
        >
          <Typography
            token={tokens.FS20FW500LH24M}
            color={colors.greyF8}
            text={title}
            textAlign="left"
          />
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      <DialogContent sx={{ padding: "35px !important" }}>
        {children}
      </DialogContent>
    </MuiDialog>
  );
};

export default Modal;

// export const Dialog = styled(Dialog)(() => ({
//   backgroundColor: colors.back21,
//   border: `1px solid ${colors.greyD9}`,
//   "& .Mui-Dialog-title": {
//     padding: "40px",
//   },
//   "& .Mui-Dialog-content": {
//     padding: "40px",
//   },
// }));
